$(document).ready(function () {
  $(".content-section-slider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Left_arrow.png?v=1720509365"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Right_arrow.png?v=1720509364"></button>`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // our process section js
  $(".net-cvr").click(function () {
    $(this).next("div").toggle(500);
    $(this).toggleClass("active");
    $(".net-cvr").not(this).removeClass("active").next("div").hide(500);
  });

  $(window).on("scroll", function () {
    var $scrollImages = $(".zoom-image"); // Use class instead of ID
    var windowHeight = $(window).height();
    var scrollPosition = $(window).scrollTop();

    $scrollImages.each(function () {
      var imagePosition = $(this).offset().top;

      if (scrollPosition > imagePosition - windowHeight) {
        $(this).css({
          opacity: 1,
          transform: "scale(1)",
        });
      } else {
        $(this).css({
          opacity: 0,
          transform: "scale(0.8)", // Revert to initial scale
        });
      }
    });
  });

  $(".image-section-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Drop_down_icon_1.png?v=1721190138"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Drop_down_icon_4bb325d8-ac76-4db5-bb37-6dcbde0d4a5a.png?v=1721190137"></button>`,
    asNavFor: ".image-content-slider",
    centerMode: true,
    centerPadding: "550px",
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          centerMode: true,
          centerPadding: "220px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          centerMode: true,
          centerPadding: "100px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "30px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".image-content-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".image-section-slider",
    arrows: true,
    dots: false,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Drop_down_icon_1.png?v=1721190138"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Drop_down_icon_4bb325d8-ac76-4db5-bb37-6dcbde0d4a5a.png?v=1721190137"></button>`,
  });

  $(".cotinues-slider").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          arrows: false,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          arrows: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 3,
        },
      },
    ],
  });

  $(".image-section-slider-part").slick({
    dots: false,
    prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Drop_down_icon_1.png?v=1721190138"></button>`,
    nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0889/2150/6104/files/Drop_down_icon_4bb325d8-ac76-4db5-bb37-6dcbde0d4a5a.png?v=1721190137"></button>`,
    autoplay: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });


  $(document).on('change', 'fieldset.select-size input[type="radio"]', function () {
    var variantId = $(this).data('variant-id');
    console.log("variantId", variantId);
    if (!variantId) return;
    var quantity = window.variantCartons[variantId];
    console.log("quantity", quantity);
    if (quantity) {
      $('.par-bags-quntity p').text(quantity);
      console.log("updated quantity", quantity);
    }
  });


});
